import {
  getAccountNumberFormat
} from '@/api/coreSettings'

const getDefaultState = () => {
  return {
    accountNumberFormat: {
      accountNumberLength: 16,
      customPrefix: ''
    }
  }
}

const state = getDefaultState()

const getters = {
  accountNumberPrefix: ({ accountNumberFormat: { customPrefix } }) => customPrefix,
  accountNumberTotalLength: ({ accountNumberFormat: { accountNumberLength, customPrefix } }) => customPrefix.length + accountNumberLength,
  accountNumberFormat: (state) => state.accountNumberFormat
}

const mutations = {
  resetState (state) {
    Object.assign(state, getDefaultState())
  },
  fetchAccountNumberFormat (state, format) {
    state.accountNumberFormat = {
      ...state.accountNumberFormat,
      ...format
    }
  }
}

const actions = {
  resetState ({ commit }) {
    commit('resetState')
  },
  async fetchAccountNumberFormat ({ commit }) {
    const {
      data: {
        data: {
          AccountNumberFormats: {
            select: [
              format
            ]
          }
        }
      }
    } = await getAccountNumberFormat()
    commit('fetchAccountNumberFormat', format)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
